import React from 'react';
import { t, Trans } from '@lingui/macro';
import { get, times } from 'lodash';

import Modal from '@src/components/Modal';
import Separator from '@src/components/Separator';
// import Slider from '@src/components/Slider';
import useTourSearch from '@src/hooks/useTourSearch';
import { i18n } from '@src/i18n';
import { TermFilter } from '@src/types';

import {
  Column,
  Container,
  FilterTerm,
  Grid,
  PriceLabel,
  Row,
  SearchBar,
  SliderContainer,
  Spinner,
  TermFilterContainer,
  Title,
} from './styled';
import { Props, TermFilterItemsProps } from './types';

const TermFilterItems: React.FC<TermFilterItemsProps> = (props) => {
  const { filters, onPressTermFilter, activeTerms = {} } = props;

  return (
    <TermFilterContainer>
      <Column style={{ marginBottom: 20 }}>
        <Title>
          <Trans>Filter by Items</Trans>
        </Title>
      </Column>
      <Grid>
        {filters?.terms?.map((term) => (
          <FilterTerm
            key={term.id}
            onPress={() => onPressTermFilter?.(term)}
            active={get(activeTerms, term.id, false)}
          >
            {term.name}
          </FilterTerm>
        ))}
        {times(3).map((idx) => (
          <Separator key={idx} />
        ))}
      </Grid>
    </TermFilterContainer>
  );
};

const Component: React.FC<Props> = ({ navigation, route }) => {
  const { search, setSearch, filter, setFilter } = useTourSearch();
  const filters = route.params.filters ?? [];

  const handlePress = React.useCallback(() => {
    setSearch(search);
  }, [search, setSearch]);

  const filterTermPressHandler = (term: TermFilter): void => {
    setFilter({
      ...filter,
      activeTerms: {
        ...filter.activeTerms,
        [term.id]: !get(filter.activeTerms, term.id, false),
      },
    });
  };

  // const sliderValuesChangeHandler = (min: number, max: number): void => {
  //   setFilter({
  //     ...filter,
  //     priceRange: [min, max],
  //   });
  // };

  if (!filters.maxPrice || !filters.minPrice || !filters.terms) {
    navigation.navigate('Root');
    return null;
  }

  const minValue = filter.priceRange?.[0] ?? 300000;
  const maxValue = filter.priceRange?.[1] ?? 15000000;
  // const totalMin = filters?.minPrice ?? 0;
  // const totalMax = filters?.maxPrice ?? 100;
  // const step = 100000;

  return (
    <Modal>
      <Container>
        <Separator />
        <Row>
          <SearchBar
            onIconPress={handlePress}
            onSubmitEditing={handlePress}
            value={search}
            onChangeText={setSearch}
            placeholder={i18n._(t`Search...`)}
          />
        </Row>
        <Separator />
        <Row>
          <Column>
            <Title>
              <Trans>Price Range</Trans>
            </Title>
            {!filters ? (
              <Row>
                <Spinner />
              </Row>
            ) : (
              <>
                <Row style={{ width: '90%' }}>
                  <PriceLabel>
                    <Trans>From: {minValue}</Trans>
                  </PriceLabel>
                  <PriceLabel>
                    <Trans>To: {maxValue}</Trans>
                  </PriceLabel>
                </Row>
                <SliderContainer>
                  {/* <Slider
                    onChangeValues={sliderValuesChangeHandler}
                    step={step}
                    min={totalMin}
                    max={totalMax}
                    low={minValue}
                    high={maxValue}
                  /> */}
                </SliderContainer>
              </>
            )}
          </Column>
        </Row>
        <Separator level={2} />
        <Row>
          <TermFilterItems
            filters={filters}
            activeTerms={filter.activeTerms}
            onPressTermFilter={filterTermPressHandler}
          />
        </Row>
      </Container>
    </Modal>
  );
};

export default Component;
